/*
 * Behavior unique to OUP that was not covered in SCM.SharedWidgets.JournalCitationFilter.js
*/
var SCM = SCM || {};

SCM.OUPJournalCitationFilter = (function (ns, $) {
    var journalCitationToggleClass = '.js-journal-citation-filter-toggle';
    var collapsedIconClass = 'journal-citation-filter-icon-filled-down';
    var expandedIconClass = 'journal-citation-filter-icon-filled-up';

    function init() {
        $(document).on('click', journalCitationToggleClass, function () {
            citationDropdownToggle();
        });
    }

    //icon arrow aria expanded toggle
    function citationDropdownToggle() {
        var $journalCitationToggle = $('.js-journal-citation-filter-toggle');
        if ($journalCitationToggle.hasClass(collapsedIconClass)) {
            expandCitationDropdown($journalCitationToggle);
        } else {
            collapseCitationDropdown($journalCitationToggle);
        }
    }

    function expandCitationDropdown($journalCitationToggle) {
        $journalCitationToggle.attr('aria-expanded', 'true');
        $journalCitationToggle.removeClass(collapsedIconClass);
        $journalCitationToggle.addClass(expandedIconClass);
    }

    function collapseCitationDropdown($journalCitationToggle) {
        $journalCitationToggle.attr('aria-expanded', 'false');
        $journalCitationToggle.removeClass(expandedIconClass);
        $journalCitationToggle.addClass(collapsedIconClass);
    }

    return {
        init: init
    };

})(SCM.OUPJournalCitationFilter = SCM.OUPJournalCitationFilter || {}, jQuery);

$(document).ready(function () {
    if (!SCM.JournalCitationFilter.journalCitationFilterLoaded()) {
        return;
    }

    SCM.OUPJournalCitationFilter.init();
});